import {
  abandonInFlightPortalJourneys,
  abandonStaleOtpRoundTripJourney,
} from './portalJourney';

let isInstalled = false;

export const resetPortalJourneyUnloadListenerForTests = (): void => {
  isInstalled = false;
};

export const installPortalJourneyUnloadListener = (): void => {
  if (isInstalled || typeof window === 'undefined') {
    return;
  }

  isInstalled = true;

  window.addEventListener('pagehide', () => {
    abandonInFlightPortalJourneys({ reasonCode: 'page-unload' });
  });
};

export const reconcileStalePortalJourneysOnLoad = (
  shouldSkipOtpRoundTripAbandon: () => boolean
): void => {
  if (shouldSkipOtpRoundTripAbandon()) {
    return;
  }

  abandonStaleOtpRoundTripJourney({
    reasonCode: 'otp-round-trip-never-returned',
  });
};
